<bazis-input-default
    *ngIf="{ valueChanges: valueChanges$ | async } as data"
    [rows]="rows"
    [minlength]="minlength"
    [maxlength]="maxlength"
    [required$]="required$"
    [tooltipKey]="tooltipKey"
    [tooltipSettings]="tooltipSettings"
    [titleKey]="titleKey"
    [noteKey]="noteKey"
    [tooltipParams]="tooltipParams"
    [titleParams]="titleParams"
    [hasTitleMajor]="hasTitleMajor"
    [noteParams]="noteParams"
    [emptyValue]="emptyValue"
    [validationErrorMessages]="validationErrorMessages"
    [formControl]="field"
    [sizeControl]="sizeControl"
>
    <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
</bazis-input-default>
